import React from "react"
import styles from "./text.module.scss"
import {GreenUpColor, mapGreenUpColorToCssClass} from "../../util/greenup-colors/green-up-color"

function colorToCss(color: GreenUpColor | undefined): string {
  return color ? mapGreenUpColorToCssClass(color) : ""
}

interface TextProps {
  color?: GreenUpColor
  personalData?: boolean
}

export const TextLarge: React.FC<TextProps> = ({children, color, personalData = false}) => (
  <p className={`${styles.TextLarge} ${colorToCss(color)}`} data-hj-suppress={personalData ? true : undefined}>
    {children}
  </p>
)

export const TextMedium: React.FC<TextProps> = ({children, color, personalData = false}) => (
  <p className={`${styles.TextMedium} ${colorToCss(color)}`} data-hj-suppress={personalData ? true : undefined}>
    {children}
  </p>
)

export const TextSmall: React.FC<TextProps> = ({children, color, personalData = false}) => (
  <p className={`${styles.TextSmall} ${colorToCss(color)}`} data-hj-suppress={personalData ? true : undefined}>
    {children}
  </p>
)

export const TextMessage: React.FC<TextProps> = ({children, color, personalData = false}) => (
  <p className={`${styles.TextMessage} ${colorToCss(color)}`} data-hj-suppress={personalData ? true : undefined}>
    {children}
  </p>
)
